import React from 'react'
import Collapsible from 'react-collapsible'
import { Set } from 'immutable'
import { planDetails } from '../../constants'

import { PlanFragment, StripeSubscription } from 'src/graphql'
import { useState } from 'src/hooks'
import { DecoratedPlan } from 'src/redux/selectors/plans'
// relative imports
import PlanTile from './PlanTile'
import RoundedFooter from './RoundedFooter'
import MobileFeatureCell from './MobileFeatureCell'

import { Text } from '@sendoutcards/quantum-design-ui'
import Disclaimer from './Disclaimer'
import { discountDisclaimer } from './PricingTable'

type MobilePricingTableProps = {
  plans: DecoratedPlan[]
  onSelect: (plan: string, isKeepButton?: boolean) => void
  stripeSubscription?: Partial<StripeSubscription>
  getPlan: (planId: string) => PlanFragment | undefined
}

const MobilePricingTable: React.FC<MobilePricingTableProps> = props => {
  const { plans, onSelect, stripeSubscription, getPlan } = props
  const visiblePlans = plans.filter(plan => plan.title !== 'Basic')
  const [openPlans, setOpenPlans] = useState<Set<number>>(Set())

  const togglePlan = (index: number) =>
    setOpenPlans(
      openPlans.has(index) ? openPlans.delete(index) : openPlans.add(index),
    )

  return (
    <>
      {visiblePlans.map((plan, index) => (
        <React.Fragment key={plan.title}>
          <PlanTile
            plan={plan}
            onSelect={onSelect}
            stripeSubscription={stripeSubscription}
            getPlan={getPlan}
          />
          <RoundedFooter
            isOpen={openPlans.contains(index)}
            actionTitle={'View Features'}
            onClick={() => togglePlan(index)}
            shouldDisclaimerBeVisible={false}
          />
          <Collapsible trigger="" open={openPlans.contains(index)}>
            <ul
              style={{
                padding: '15px',
                background: 'rgb(241, 241, 241)',
                borderRadius: '5px',
              }}
            >
              {planDetails
                .find(p => p.plan === plan.title)
                ?.details.map(detail => (
                  <li
                    key={detail.detail}
                    style={{
                      ...{
                        listStyleType: 'none',
                        padding: '3px 0',
                        borderBottom: `${
                          detail.innerDetails ? 'none' : 'solid 1px #ccc'
                        }`,
                      },
                    }}
                  >
                    {detail.innerDetails && (
                      <>
                        <Text type="body" weight="bold">
                          {detail.detail}
                        </Text>
                        <ul>
                          {detail.innerDetails.map(innerDetail => (
                            <li
                              key={innerDetail.detail}
                              style={{
                                ...{
                                  listStyleType: 'none',
                                  padding: '3px 0',
                                  borderBottom: 'solid 1px #ccc',
                                },
                              }}
                            >
                              <Text type="body" inset={{ left: 'x1_5' }}>
                                {innerDetail.detail}
                              </Text>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                    {!detail.innerDetails && (
                      <Text type="body">{detail.detail}</Text>
                    )}
                  </li>
                ))}
            </ul>
          </Collapsible>
          <MobileFeatureCell plan={plan} isOpen={openPlans.contains(index)} />
        </React.Fragment>
      ))}
      <Disclaimer messages={discountDisclaimer} />
    </>
  )
}

export default MobilePricingTable
